// Fase 0 Estrategia Google — beacon de clique no WhatsApp da vitrine.
// As aberturas da vitrine e as views de produto sao contadas server-side (nas
// rotas GET do catalogo). Aqui so o clique no botao de WhatsApp, que e uma acao
// no navegador que o servidor nao enxerga sozinho.
// Usa sendBeacon: dispara de forma confiavel mesmo com a pagina saindo pro WhatsApp.
export function pingWhatsapp(produtoId?: number | null): void {
  try {
    const body = JSON.stringify({ tipo: 'whatsapp', produto_id: produtoId ?? undefined });
    const blob = new Blob([body], { type: 'application/json' });
    navigator.sendBeacon('/api/public/catalogo/evento', blob);
  } catch {
    /* metrica nunca pode atrapalhar o clique do cliente */
  }
}
